import { createContext } from "react";

const doctorcontext = createContext();

export default doctorcontext;